/** @jsx jsx */
import { jsx, css } from "@emotion/core"
import { IconButton, IconButtonProps } from "@material-ui/core"
import DeleteIcon from "@material-ui/icons/ClearRounded"
import { Theme } from "../../types"

type Props = {
    testId?: string
    onRemove: () => void
} & IconButtonProps

function DeleteIconButton({ onRemove, ...props }: Props) {
    return (
        <IconButton
            {...props}
            onClick={onRemove}
            css={styles.root}
            data-testid={props.testId}
        >
            <DeleteIcon />
        </IconButton>
    )
}

export default DeleteIconButton

const styles = {
    root: (theme: Theme) => css`
        color: ${theme.colors.red[600]};
    `,
}
